<template>
  <div class="expander" aria-haspopup="true" v-bind:aria-label="headline" v-bind:aria-expanded="expandedDisplay" v-bind:aria-controls="controls">
    <div class="expander__headline" :class="{ expanded : expanded }">
      <el-row type="flex" align="middle">
        <el-col :span="20">
          <slot name="headline" class="expander__title"></slot>
        </el-col>
        <el-col :span="4">
          <el-button class="expander__toggle" :class="{'el-col-24': !removable}" v-on:click.prevent="toggleContent()" type="text">
            <span class="sr-only sr-only-focusable">Expand</span>
            <i :class="{'el-icon-minus': expanded, 'el-icon-plus': !expanded }"></i>
          </el-button>
          <el-button v-if="removable" title="Remove" class="expander__remove" v-on:click.prevent="handleRemove()" type="text">
            <span class="sr-only sr-only-focusable">Remove</span>
            <i class="el-icon-delete"></i>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="expander__content" :class="{ expanded : expanded }" v-bind:aria-hidden="expandedDisplay" v-bind:id="controls">
      <transition
        name="slide"
        v-on:before-enter="zeroHeight"
        v-on:enter="currentHeight"
        v-on:after-enter="autoHeight"
        v-on:before-leave="currentHeight"
        v-on:leave="leave"
      >
        <div class="expander__content--wrap" v-if="expanded">
          <div class="expander__content--inner" ref="contentInner">
            <slot></slot>
          </div>
        </div>
      </transition>
      <div class="expander__content--wrap" v-if="!expanded"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'events',
    data() {
      return {
        expanded: false
      }
    },
    props: {
      headline: String,
      initiallyExpanded: Boolean,
      removable: Boolean,
    },
    computed: {
      controls() { return 'expander-' + this._uid },
      expandedDisplay() { return this.expanded; }
    },
    methods: {
      toggleContent() { this.expanded = !this.expanded; },
      getHeight() { return this.$refs.contentInner.offsetHeight },
      leave(el) { setTimeout(() => { this.zeroHeight(el) }, 0); },
      currentHeight(el) { el.style.height = this.getHeight() + 'px'; },
      zeroHeight(el) { el.style.height = '0'; },
      autoHeight(el) { el.style.height = 'auto'; },
      handleRemove() { this.$emit('remove'); },
    },
    mounted
  }

  //////////

  function mounted() {
    if((this.initiallyExpanded === true) || (this.initiallyExpanded === 'true')) {
      setTimeout(()=>{
        this.toggleContent();
      }, 0);
    }
  }
</script>

<style lang="scss" scoped>

  .slide-enter-active,
  .slide-leave-active {
    transition: height 300ms;
    overflow: hidden;
  }

</style>
